import { useTranslation } from "react-i18next";
import {
  getLessonHook,
  useCreateLessonHook,
  useGetLessonHook,
} from "@packages/api/madlenAPI";
import { LessonHookResponseDto } from "@packages/api/madlenAPI.schemas";
import CreateModal, {
  CreateModalProps,
} from "../../../components/create-modal";
import { HookCard } from "../../../components/hooks/HookCard";
import GenericToolCreationPage from "../../../components/tool_components/GenericToolCreationPage";

const CreateHookView = () => {
  const { t } = useTranslation();

  const CreateModalWrapper = ({
    initialInput,
    onSubmit,
    isLoading,
    error,
  }: Partial<CreateModalProps>) => (
    <CreateModal
      title={t("hooks.result.loading.title")}
      backPath="/content/hooks"
      themeColor="blue"
      loadingTitle={t("hooks.result.loading.title")}
      errorTitle={t("hooks.result.error.title")}
      errorDescription={t("hooks.result.error.description")}
      submitButtonText={t("common.generate")}
      initialInput={initialInput!}
      onSubmit={onSubmit!}
      isLoading={isLoading!}
      error={error!}
    />
  );

  const ToolCardWrapper = ({
    toolData,
    isImageLoading,
    onCreateAgain,
  }: {
    toolData: LessonHookResponseDto;
    isImageLoading: boolean;
    onCreateAgain: () => void;
  }) => (
    <HookCard
      lessonHook={toolData}
      isImageLoading={isImageLoading}
      onCreateAgain={onCreateAgain}
    />
  );

  return (
    <GenericToolCreationPage
      toolType="hooks"
      useCreateTool={useCreateLessonHook}
      useGetTool={useGetLessonHook}
      getTool={getLessonHook}
      ToolCard={ToolCardWrapper}
      CreateModalWrapper={CreateModalWrapper}
      toolDataExtractor={(data: LessonHookResponseDto) =>
        data?.hooks && Array.isArray(data?.hooks) && data?.hooks?.length > 0
      }
    />
  );
};

export default CreateHookView;
